import axios from '../../../axios';
import ClientLegelDTO from '../types/ClientLegelDTO';

const url = 'invoicingservice/api/client-legal';

export const getClientLegal = (clientId: string) => axios.post(`${url}/${clientId}/list`);
export const saveClientLegal = (payload: ClientLegelDTO) => axios.post(`${url}/save`, payload);
export const deleteClientLegal = (id: string) => axios.delete(`${url}/delete-by-id/${id}`);
